<template>
  <Catalog
    title="Статус лида"
    name-label="Название статуса"
    submit-error="Укажите название статуса лида."
    :fetch-data="fetchData"
    :put-data="putData"
    :post-data="postData"
    v-on="$listeners"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import Catalog from "../Catalog.vue";

export default {
  name: "LocationStatus",
  components: { Catalog },
  mixins: [ catalogs ],
  methods: {
    async fetchData(id) {
      return await this.getLeadStatusById(id);
    },
    async putData(data) {
      return await this.putLeadStatus(data)
    },
    async postData(data) {
      return await this.postLeadStatus(data)
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/LeadStatuses/LeadStatus.vue